<template>
  <div class="wrapper">
    <CalcBody :points="points" :range="range" />
  </div>
</template>

<script>
import Logo from "../components/Template/Logo";
import CalcBody from "../components/Template/CalcBody";

export default {
  props: ["points", "range"],
  components: {
    CalcBody
  },
  data() {
    return {};
  },

};
</script>

<style lang="scss" scoped>
@import "../styles/style";
</style>
